import { request } from "../utils";

export const getShortLink = params => request(`/shortUrl`, {
  method: "POST",
  data: {
    ...params,
  },
});
